import { useQuery } from '../services/NetworkManager';
import { NetworkManager } from '../services';

export type PgPaymentMode = 'UPI' | 'NEFT' | 'IMPS' | 'RTGS' | 'BANK_TRANSFER';

export type PgInformation = {
  paymentGateway?: string;
  convenienceFee?: number;
  strikedConvenienceFee?: number;
  totalPayableAmount?: number;
  buttonEnabled?: boolean;
  message?: string | null;
};

export type PgInformationParams = {
  clientPublicId: string;
  amount: number | string;
  paymentMode: PgPaymentMode;
};

export function getPgInformation({ clientPublicId, amount, paymentMode }: PgInformationParams) {
  return NetworkManager.Call({
    method: 'get',
    path: NetworkManager.PATH.pgInformation
      .replace('{{clientPublicId}}', clientPublicId)
      .replace('{{amount}}', String(amount))
      .replace('{{paymentMode}}', paymentMode),
  });
}

export default function useGetPgInformation({
  clientPublicId,
  amount,
  paymentMode,
  enabled = true,
}: Partial<PgInformationParams> & { enabled?: boolean }) {
  const isEnabled = enabled && !!clientPublicId && !!amount && !!paymentMode;

  const { data, isLoading, isError, error, refetch } = useQuery(
    ['getPgInformation', clientPublicId, amount, paymentMode],
    () => {
      if (!isEnabled) {
        return Promise.resolve(null);
      }
      return getPgInformation({
        clientPublicId: clientPublicId as string,
        amount: amount as number | string,
        paymentMode: paymentMode as PgPaymentMode,
      });
    },
    {
      enabled: isEnabled,
    },
  );

  return {
    data: data?.data as PgInformation | undefined,
    isLoading: isEnabled && isLoading,
    isError,
    error,
    refetch,
  };
}
